import { createFileRoute } from "@tanstack/react-router";

import Home from "areas/home/pages/Home";


export const Route = createFileRoute("/_private/_home/")({
	component: () => <Home />,
	staticData: {
		footer: true
	}
});